import { SvgIcon, SvgIconProps } from '@mui/material';

const ArrowUploadProgressIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40" fill="none">
      <mask
        id="mask0_2005_3632"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <rect width="40" height="40" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2005_3632)">
        <mask
          id="mask1_2005_3632"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="10"
          y="10"
          width="20"
          height="20"
        >
          <rect x="10" y="10" width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask1_2005_3632)">
          <path
            d="M15 26C13.8889 26 12.9444 25.6111 12.1667 24.8333C11.3889 24.0556 11 23.1111 11 22C11 20.9444 11.3611 20.0313 12.0833 19.2604C12.8056 18.4896 13.6875 18.0694 14.7292 18C15.0486 16.8194 15.691 15.8576 16.6562 15.1146C17.6215 14.3715 18.7361 14 20 14C21.4306 14 22.6736 14.4826 23.7292 15.4479C24.7847 16.4132 25.375 17.5972 25.5 19C26.4722 19 27.2986 19.3403 27.9792 20.0208C28.6597 20.7014 29 21.5278 29 22.5C29 23.4722 28.6597 24.2986 27.9792 24.9792C27.2986 25.6597 26.4722 26 25.5 26H15Z"
            fill="currentColor"
          />
        </g>
        <path
          d="M18.2362 36.5833C16.1251 36.3611 14.1644 35.7801 12.3541 34.8404C10.5438 33.9004 8.96742 32.6828 7.62492 31.1875C6.28242 29.6922 5.23145 27.9862 4.472 26.0696C3.71284 24.1529 3.33325 22.1204 3.33325 19.9721C3.33325 15.6482 4.76145 11.9075 7.61784 8.75C10.4745 5.5925 14.0231 3.79625 18.2637 3.36125V6.15291C14.7914 6.64347 11.898 8.19208 9.58325 10.7987C7.26853 13.4051 6.11117 16.4629 6.11117 19.9721C6.11117 23.4815 7.26395 26.5394 9.5695 29.1458C11.8751 31.7522 14.7639 33.3008 18.2362 33.7917V36.5833ZM21.7916 36.5833V33.7917C23.0508 33.6342 24.2567 33.3147 25.4095 32.8333C26.5623 32.3519 27.6248 31.7224 28.597 30.9446L30.6112 32.9721C29.3426 33.9538 27.9628 34.764 26.472 35.4029C24.9814 36.0418 23.4213 36.4353 21.7916 36.5833ZM28.6112 9.02792C27.6017 8.28708 26.5276 7.66667 25.3887 7.16667C24.2498 6.66667 23.0508 6.32875 21.7916 6.15291V3.36125C23.4213 3.54625 24.9769 3.95361 26.4583 4.58333C27.9396 5.21305 29.3239 6.01861 30.6112 7L28.6112 9.02792ZM32.972 30.4583L30.9862 28.5C31.7639 27.5092 32.3889 26.4374 32.8612 25.2846C33.3334 24.1318 33.6481 22.9258 33.8053 21.6667H36.6249C36.4396 23.2964 36.0345 24.8565 35.4095 26.3471C34.7845 27.8379 33.972 29.2083 32.972 30.4583ZM33.8053 18.2779C33.6481 17.0185 33.3334 15.8078 32.8612 14.6458C32.3889 13.4839 31.7639 12.4168 30.9862 11.4446L33.0833 9.51375C34.0646 10.7824 34.8587 12.1574 35.4653 13.6388C36.0717 15.1204 36.4583 16.6668 36.6249 18.2779H33.8053Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};

export default ArrowUploadProgressIcon;
